export const getMachineState = (machineStateValue = 0) => {
  switch (machineStateValue) {
    case 1:
      return "STARTING";
    case 2:
      return "RUNNING";
    case 3:
      return "STOPPING";
    case 4:
      return "STOPPED";
    default:
      return "STOPPED";
  }
};

export const isMachineInActiveState = (machineStateValue = 0) => {
  const machineState = getMachineState(machineStateValue);
  return machineState === "RUNNING";
};
